export type Author = {
  age: number;
  authorId: number;
  bio: string;
  country: string;
  gender: string;
  healthInterests: {name: string}[];
  id: number;
  avatarMedium: string;
  isDeleted: boolean;
  profileImageSmall2x?: string;
  roles: string[];
  username: string;
  userImageHash: string;
}

export type EditAuthor = {
  username: string;
  roles: string[];
}

export type MentionedUser = {
  userId: number;
  username: string;
}

export type Reply = {
  author: Author;
  body: string;
  enriched: any;
  id: number;
  imageDescription: string | null;
  imagePreview: string | null;
  imageUrl: string | null;
  indent: number;
  mentionedUsers: MentionedUser[];
  order: string;
  parentPostId: number;
  postImageHash: string | null;
  numRatings: number | string;
}

export type Tag = {
  name: string;
  nodeId: string;
  urlEncodedName: string;
}

type Entity = {
  slug: string;
  name: string;
  shortName: string;
}

export type Post = {
  author: Author;
  body: string;
  dateCreated: string;
  dateLastActivity: string;
  editAuthor: EditAuthor | null;
  enriched: any;
  entities: Entity[];
  id: number;
  imageDescription?: string | null;
  imagePreview?: string | null;
  imageUrl: string | null;
  isFollowing: boolean;
  isLocked: boolean;
  isPrivate: boolean;
  mentionedUsers: MentionedUser[];
  postImageHash: string | null;
  postTypeId: PostType;
  postUrl: string;
  repliesCount: number;
  responses: Reply[];
  tags: Tag[];
  title: string;
  totalResponses: number;
  url: string;
  urlEncodedTitle: string;
  numRatings: number | string;
}

export type Featured = {
  branch: undefined | 'A' | 'B';
  callToActionText: string;
  callToActionUrl: string;
  communityLogoImageMedium: string;
  featuredByCommunityName: string;
  featuredPostId: number;
  imageUrl?: string;
  logoImageHash: string;
  snippet: string;
  title: string;
}

export enum PostType {
  Post = 4,
  Poll = 6,
}
